<template>
  <v-container
    fluid
  >
    <v-text-field
      class="ma-2"
      flat
      hide-details
      clearable
      label="Search"
      prepend-inner-icon="mdi-comment-search"
      solo
      v-model="search"
    ></v-text-field>

  <QuoteItem v-for="quote in quotes" :key="quote.id" :quote="quote"/>

  </v-container>
</template>

<script>

import QuoteItem from '../../components/QuoteItem.vue'

export default {
  name: 'HomeDefault',

  components: {
    QuoteItem
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    quotes () {
      if (this.search) {
        const needle = this.search.toLowerCase()
        return this.$store.state.quotes.filter((q) => q.quote.toLowerCase().indexOf(needle) !== -1)
      }
      return this.$store.state.quotes
    }
  }
}
</script>
